import { AutoBet } from '../../../../components/common/bettingPart';
import { AutoCashOut } from './autoCashOut';

export const AutoBetEndCashOutSection = ({ t, handleOpenNumPad }) => {
  return (
    <div className='game-bet-block right-cl'>
      <div className='game-bet-bl-main-box'>
        <AutoCashOut t={t} handleOpenNumPad={handleOpenNumPad} />
        <AutoBet t={t} />
      </div>
    </div>
  );
};
